<template>
    <modal @close="close" :show-title="true" :size="'medium'">
        <div slot="header">
            <h5 class="modal-title">{{$t('carrello.scadenza_carrello')}}</h5>
        </div>
        <div slot="body" class="text-center">
            <img src="/img/be/ico-scadenza.png"><br><br>
            {{$t('carrello.rimangono_min')}}<br>
            <p class="f3 red" style="padding:15px 0;">
                <span>{{this.minutes}}</span> {{$t('carrello.scadenza_minuti')}}
            </p>
            <span v-html="$t('carrello.disponibilita_non_garantita')"></span>
        </div>
        <div slot="footer">
            <button type="button" class="btn btn-primary" @click="close()">ok</button>
        </div>
    </modal>
</template>

<script>
    import {mapActions, mapState} from 'vuex';

    import Modal from '../../partials/Modal';

    export default {
        name: "ModalCartTimer",
        components: {Modal},
        computed: {
            ...mapState('global', {
                minutes: state => state.modal_cart_timer_minutes
            })
        },
        methods: {
            close: function () {
                this.showModalCartTimer({
                    show: false,
                    minutes: null
                });
            },
            ...mapActions('global', [
                'showModalCartTimer'
            ])
        }
    }
</script>
